
import {
	SET_ERROR,
} from '../../types'

import  errorMessage  from '../../error'



export function setError(hasError, error = null) {

	var defaultError = {
		code: "00010000",
		message: errorMessage ? errorMessage["00010000"] : "",
	}

	if(typeof error === 'string' && error in errorMessage) {
		defaultError = {
			code: error,
			message: errorMessage[error],
		}
	} else if(error !== null && error !== undefined && error.code !== undefined && error.message !== undefined) {
		defaultError = error
	} else if(error === null || hasError === false) {
		defaultError = null
	}

	return {
		type: SET_ERROR,
		hasError: hasError,
		error: defaultError,
	}
}


// WEBPACK FOOTER //
// ./src/features/ui/actions.js